var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchDarkMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 49.013,
    viewBox: "0 0 40 49.013",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801",
    transform: "translate(-407.702 -926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3658",
    "data-name": "Group 3658",
    transform: "translate(820.702 139.013)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Search",
    transform: "translate(-413 832)",
    fill: "#000",
    fontSize: 11,
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Search"))), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Broken_Search",
    "data-name": "Iconly/Broken/Search",
    transform: "translate(414 926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-2",
    "data-name": "Search",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search-3",
    "data-name": "Search",
    d: "M26.082,24.565l-4.538-4.437h0l-.106-.162a1.069,1.069,0,0,0-1.5,0h0a10.711,10.711,0,0,1-13.887.449A10.138,10.138,0,0,1,3.8,7.011,10.662,10.662,0,0,1,17.1,3.092a10.221,10.221,0,0,1,5.7,12.391,1.028,1.028,0,0,0,.24,1.019,1.085,1.085,0,0,0,1.022.306,1.06,1.06,0,0,0,.782-.712h0a12.323,12.323,0,0,0-6.6-14.853A12.878,12.878,0,0,0,2.23,5.394a12.22,12.22,0,0,0,1.8,16.1,12.924,12.924,0,0,0,16.549.68L24.593,26.1a1.081,1.081,0,0,0,1.5,0,1.035,1.035,0,0,0,0-1.479h0Z",
    transform: "translate(0)",
    fill: "#000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDarkMobile);
export default __webpack_public_path__ + "static/media/search-dark-mobile.2d1050b9b1c58dcf3d88d778cc00d3a0.svg";
export { ForwardRef as ReactComponent };